import { apiWithAuth } from "../authApi";

export const postUserLanguage = async (
  newLangCode: string
): Promise<unknown | undefined> => {
  try {
    const response = await apiWithAuth.post("/user/language", {
      newLangCode,
    });

    const data = response.data;

    return data;
  } catch (error) {
    return undefined;
  }
};
